import React from 'react';
import ModalComponent from '../common/modals/PatternLibModalComponent';
import BrowserUtils from '../../utils/BrowserUtils';
import NavigateToWebApps from '../../utils/NavigateToWebApps';

import PropTypes from 'prop-types';
class ErrorPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openAppErrorModal: true,
    };
  }

  componentWillMount() {
    BrowserUtils.setViewPort(1);
  }

  onLogoutClick() {
    NavigateToWebApps.navigateToLoginPage();
  }
  closeAppErrorModal() {
    this.setState({
      openCreateSweepErrorModal: !this.state.openCreateSweepErrorModal,
    });
  }
  render() {
    let body = (
      <div>
        <p>{this.props.content.errorText2}</p>
        <p>{this.props.content.errorText3}</p>
      </div>
    );
    const footerButtons = (
      <div>
        <button
          type="button"
          onClick={this.onLogoutClick}
          className="c-btn c-btn--default c-modal__button"
        >
          Log out
        </button>
      </div>
    );
    return (
      <div className="nonbcustomer">
        <ModalComponent
          show={this.state.openAppErrorModal}
          onHide={() => {}}
          customClass="c-modal"
          modalBody={body}
          bsSize="medium"
          modalHeading={this.props.content.errorText1}
          modalFooter={footerButtons}
          closeButton={false}
        />
      </div>
    );
  }
}

ErrorPage.propTypes = {
  content: PropTypes.object,
};

ErrorPage.defaultProps = {};

export default ErrorPage;
